module.exports = __webpack_public_path__ + "img/vehicle-speed.665b833d.svg";